import { CompanyHint } from '@/models/hints'

export interface HintsState {
  list: CompanyHint[]
}

export const initialState: HintsState = {
  list: [],
}
